module.exports = __webpack_public_path__ + "assets/img/driver-btn-acb4d904.png";